import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import 'toastr/build/toastr.css';
import App from "./App";
import { createLogger } from "redux-logger";
import { Provider } from "react-redux";
import reducers from "./app/root_reducer";
import toastr from 'toastr';
import {bottom_full_width} from '~/app/utilities/index'
import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
//import api from './middleware/api'
import registerServiceWorker from "./registerServiceWorker";
import ReactModal from "react-modal";

toastr.options= bottom_full_width;
const logger = createLogger();
let createStoreWithMiddleware = applyMiddleware(thunkMiddleware, logger)(
  createStore
);
let store = createStoreWithMiddleware(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root"),
  ReactModal.setAppElement(document.getElementById("root"))
);

registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js